import React, { useContext, useEffect } from 'react';
import EntityManager from '../common/EntityManager';
import OrganizationModal from './OrganizationModal';
import FacilityModal from './FacilityModal';
import { OrganizationFacilityContext } from '../../context';

const SideBar = () => {
  const {
    organizationState: {
      selectedOrganization,
      showOrganizationModal,
      isEditingOrg,
      organizationModalAction,
    },
    organizationActions: {
      setShowOrganizationModal,
      getFilteredOrganizations,
      handleSelectOrganization,
      handleAddOrganization,
      handleEditOrganization,
      handleToggleOrganizationStatus,
      handleSaveOrganization,
      handleOrganizationSearch,
    },
    facilityState: {
      selectedFacility,
      facilityAddressDetails,
      isEditingFacility,
      showFacilityModal,
      facilityModalAction,
    },
    facilityActions: {
      setShowFacilityModal,
      handleFacSelectOrganization,
      handleSelectFacility,
      handleAddFacility,
      handleEditFacility,
      handleSaveFacility,
      handleToggleFacilityStatus,
      handleFacOrganizationSearch,
      getFilteredOrganizationFacilities,
    },
  } = useContext(OrganizationFacilityContext);

  useEffect(() => {
    const fetchFacilities = () => {
      if (selectedOrganization) {
        handleFacSelectOrganization(selectedOrganization);
      }
    };

    fetchFacilities();
  }, [selectedOrganization, handleFacSelectOrganization]);

  // disable actions list organization
  const disableOrganizationActions = !selectedOrganization;
  // disable add button facilty
  const disableAddNewFacility = !selectedOrganization;
  // disable actions list organizations
  const disableFacilityActions = !selectedOrganization || !selectedFacility;
  // Status Facility
  const facilityStatus = selectedFacility?.is_active || false;
  // Status organization
  const organizationStatus = selectedOrganization?.is_active || false;
  // Facility Dropdown status
  const disableFacilityDropdown = !selectedOrganization;

  return (
    <div className="w-full xl:w-1/4 bg-custom-light-gray pb-24 lg:pb-4 p-4 order-2 xl:order-none ">
      <div className="flex flex-col mb-6">
        <span className="font-bold">Edit or add</span>
        <span>organizations and facilities</span>
      </div>
      <EntityManager
        options={getFilteredOrganizations()}
        selectedEntity={selectedOrganization}
        entity="Organizations"
        handleSelectEntity={handleSelectOrganization}
        handleEditEntity={handleEditOrganization}
        handleAddOEntity={handleAddOrganization}
        disableActions={disableOrganizationActions}
        entityStatus={organizationStatus}
        handleToggleEntityStatus={handleToggleOrganizationStatus}
        handleEntitySearch={handleOrganizationSearch}
      />
      <EntityManager
        options={getFilteredOrganizationFacilities()}
        handleSelectEntity={handleSelectFacility}
        handleEditEntity={handleEditFacility}
        handleAddOEntity={handleAddFacility}
        selectedEntity={selectedFacility}
        disableAddNewEntity={disableAddNewFacility}
        disableActions={disableFacilityActions}
        entityStatus={facilityStatus}
        disableDropdown={disableFacilityDropdown}
        entity="Facilities"
        handleToggleEntityStatus={handleToggleFacilityStatus}
        handleEntitySearch={handleFacOrganizationSearch}
      />

      {/* Modal for adding and editing organizations */}
      {showOrganizationModal && (
        <OrganizationModal
          action={organizationModalAction}
          organization={isEditingOrg ? selectedOrganization : {}}
          onSave={handleSaveOrganization}
          onClose={() => setShowOrganizationModal(false)}
        />
      )}

      {/* Modal for adding o editing facilities */}
      {showFacilityModal && (
        <FacilityModal
          action={facilityModalAction}
          facility={isEditingFacility ? selectedFacility : {}}
          address={facilityAddressDetails}
          onSave={handleSaveFacility}
          onClose={() => setShowFacilityModal(false)}
        />
      )}
    </div>
  );
};

export default SideBar;
